angular.module('pipNavHeader', ['ngMaterial', 'pipNav.Templates']);

import './NavHeaderService';
import './NavHeader';

export * from './NavHeaderService';